/**
 * When fetching content from builder.io we need to specify the model type.
 * Most content will come in the form of a page or a section, but any custom data model that we
 * want to query will have to be added here.
 * @see https://www.builder.io/c/docs/models-pages
 */
export enum BaseModelTarget {
  Section = 'section',
  Tile = 'tile'
}

/**
 * Model targets when the content is a data model.
 */
export enum DataModelTarget {
  NavigationContentModel = 'navigation',
  MarketingBannerModel = 'marketing-banner',
  CategoryModel = 'category',
  ProductModel = 'product',
  PageModel = 'page',
  PromotionMessageModel = 'promotion-message'
}

/**
 * Combined model targets for builder.io content.
 */
export const ModelTarget = { ...BaseModelTarget, ...DataModelTarget };

/**
 * Represents the target model for builder.io content.
 */
export type ModelTarget = BaseModelTarget | DataModelTarget;
